var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19 13H5v-2h14v2z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

Remove.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Remove;

Remove.default = Remove;
